import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux'
import './CurrentDetailsRow.css'
import ReactEcharts from 'echarts-for-react'
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { getEarningsTimeSeriesChart } from '../charts.js'
import { setSelectedChars } from '../../../actions/data.js'
import { getSelectedChars } from '../../../reducers/data.js'
import { faAngleDown, faAngleUp, faClock } from '@fortawesome/free-solid-svg-icons'

library.add(faAngleUp, faAngleDown, faClock)
class CurrentDetailsRow extends Component {
  state = { showing: false }

  formatPercent(number) {
    return number !== null && isNaN(number) === false ? `${parseFloat(number * 100).toFixed(1)}%` : '-'
  }
  formatDecimal(number) {
    return number !== null ? parseFloat(number).toFixed(2) : '-'
  }
  formatNumber(number) {
    return number !== null ? parseFloat(number).toFixed(0) : '-'
  }
  formatDate(string) {
    return new Date(string).toLocaleDateString([], { timeZone: 'UTC' })
  }
  setSelectedChars(char) {
    this.props.setSelectedChars(char)
    this.setState({ showing: !this.state.showing })
  }

  render() {
    const { type, data, selectedChars, earningsAggsAll, earningsType, selectedPeriodOption, selectedRangeOption } = this.props
    const { showing } = this.state

    let tierOneFilter = []
    if (earningsType === 'growth-all') {
      tierOneFilter = 'All'
    } else if (earningsType === 'growth-rpt') {
      tierOneFilter = 'Reported'
    } else {
      tierOneFilter = 'Reported'
    }

    let periodOption = selectedPeriodOption[0]
    let charName = data.tierTwo

    const filterParams = earningsAggsAll.filter(x => x.displayRange === selectedRangeOption[0])
    let filterParamsED = filterParams.map(item => item.periodEndD)

    const withData = earningsAggsAll
      .filter(x => x.tierTwo === selectedChars)
      .filter(x => x.periodicity === periodOption)
      .filter(x => x.tierOne === tierOneFilter)

    let withDataLevel2 = JSON.parse(JSON.stringify(withData))
    withDataLevel2 = withDataLevel2.filter(x => {
      let date = new Date(x.periodEndD)
      let filterDate = new Date(filterParamsED[0])
      return date <= filterDate
    })

    let total = data.cntTotal

    return (
      <Fragment>
        <tr>
          {total > 0 && (
            <td className='textLeft'>
              <div onClick={() => this.setSelectedChars(charName)} style={{ cursor: 'pointer' }}>
                {<FontAwesomeIcon style={{ color: '#050139' }} icon='clock' />}
                &nbsp;&nbsp;{charName}
              </div>
            </td>
          )}
          {total === 0 && (
            <td className='textLeft'>
              <div>
                {<FontAwesomeIcon style={{ color: '#8c959b' }} icon='clock' />}
                &nbsp;&nbsp;{charName}
              </div>
            </td>
          )}
          {earningsType === 'growth-all' && <td className={'textCenter'}>{data.cntTotal}</td>}

          {earningsType !== 'growth-all' && (
            <td className={'textCenter'}>
              {data.countReport} / {data.cntTotal}
            </td>
          )}
          {earningsType !== 'growth-all' && <td className={'textCenter'}>{this.formatPercent(data.wgtReported)}</td>}
          <td className={'textCenter'}>{this.formatPercent(data.wgtIndex)}</td>

          {type === 'surprise' && <td className={'textCenter'}>{this.formatPercent(data.salesSurprise)}</td>}

          {type === 'surprise' && <td className={'textCenter'}>{this.formatPercent(data.epsSurprise)}</td>}

          {type === 'growth' && <td className={'textCenter'}>{this.formatPercent(data.salesBlendedGrowth)}</td>}

          {type === 'growth' && <td className={'textCenter'}>{this.formatPercent(data.epsBlendedGrowth)}</td>}
        </tr>

        <Fragment>
          {showing === true && selectedChars === charName && (
            <tr>
              <td colSpan='7'>
                <div className={'chartContainer'}>
                  <ReactEcharts option={getEarningsTimeSeriesChart(withDataLevel2, charName, type)} theme='default' style={{ height: 400 }} />
                </div>
              </td>
            </tr>
          )}
        </Fragment>
      </Fragment>
    )
  }
}

function mapStateToProps(state) {
  return {
    //  data: state.fundData.data,
    selectedChars: getSelectedChars(state),
    earningsAggs: state.data.earningsAggs,
    earningsAggsAll: state.data.earningsAggsAll,
    earningsType: state.data.earningsType,
    growthType: state.data.growthType,
    selectedPeriodOption: state.data.selectedPeriodOption,
    selectedRangeOption: state.data.selectedRangeOption
    // entityOption: getSelectedChars(state),
  }
}

export default connect(mapStateToProps, {
  setSelectedChars
})(CurrentDetailsRow)



// WEBPACK FOOTER //
// ./src/components/App/CurrentDetailsTable/CurrentDetailsRow.js